import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
	Card,
	CardContent,
	makeStyles,
	CardHeader,
	Typography,
	DialogContent,
} from '@material-ui/core';
import { InvestigationDetails, LoadingProps } from '../../@types';
import { deleteInvestigation, getInvestigation } from '../../axios/investigations';
import { blue, grey, red } from '@material-ui/core/colors';
import BackBanner from '../../common/Banners/BackBanner';
import { useEffect, useState } from 'react';
import { useCardStyles } from '../../App';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import theme from '../../theme';
import ItemList from '../../common/List/ItemList';
import Box from '@material-ui/core/Box';
import { AccountCircle, MoreVert } from '@material-ui/icons';
import Popover from '@material-ui/core/Popover';
import DeleteButton from '../../common/Button/DeleteButton';
import UpdateButton from '../../common/Button/UpdateButton';
import Dialog from '@material-ui/core/Dialog';
import UpdateInvestigation from './UpdateInvestigation';
import DeleteItemConfirmation from '../../common/Item/DeleteItemConfirmation';
import SubmitButton from '../../common/Button/SubmitButton';
import CreateTask from '../Task/CreateTask';
import Grid from '@material-ui/core/Grid';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles((theme) => ({
	root: {},
	media: {
		height: 0,
		paddingTop: '56.25%', // 16:9
	},
	text: {
		fontSize: '15px',
		['@media (max-width:400px)']: {
			fontSize: '5vw',
		},
	},
	editIcon: {
		color: theme.palette.common.white,
	},
	description: {
		margin: '0px',
	},
	members: {
		margin: '20px 0px 0px',
	},
	updateButton: {
		width: '100%',
		marginBottom: '10px'
	},
	deleteButton: {
		width: '100%'
	},
	popupButton: {
		width: '150px',
		padding: '10px',
		backgroundColor: theme.palette.primary.main
	},
	gridItemWrapper: {
		// backgroundColor: 'blue',

	},
	createItemButton: {
		backgroundColor: 'white',
		float: 'right',
		marginBottom: '8px'
	},
	userWrapper: {
		padding: '10px',
		margin: '0px 0px 10px',
		backgroundColor: theme.palette.secondary.dark,
		borderRadius: '10px',
		alignItems: 'center',
	},
	userProfile: {
		fontSize: '30px',
        width: '50px',
        transform: 'translateY(4px)',
        display: 'inline',
	},
	userName: {
		fontSize: '30px',
        display: 'inline',
    },
	userDate: {
		color: theme.palette.grey[400],
		float: 'right',
		marginRight: '10px',
	},
	image: {
		width: 'auto',
		display: 'block',
		height: '250px',
		margin: '0px auto',
		textAlign: 'center'
	},
	divider: {
		margin: '50px 0px 30px'
	},
    titleSection: {
        margin: '0px 0px 5px'
    }
}));

export const InvestigationDetail = (props: LoadingProps) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	// const id = open ? 'simple-popover' : undefined;
	const [openUpdate, setOpenUpdate] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);
	
	const handleOpenForm = () => {
		// history.push(`/investigations/new`);
		handleClose()
		setOpenUpdate(true)
	};

	const handleOpenDelete = () => {
		// history.push(`/investigations/new`);
		handleClose()
		setOpenDelete(true)
	};

	const handleCloseUpdate = () => {
		setOpenUpdate(false)
	}


	const handleCloseDelete = () => {
		setOpenDelete(false)
	}

	const cardStyles = useCardStyles();
	const { id } = useParams<any>();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const [
		Investigation,
		setInvestigation,
	] = React.useState<InvestigationDetails>({
		id: '',
		name: '',
		description: '',
		tasks: [],
		users: [],
		isOwner: false,
		expertId: '',
		created_by: '',
		date_created: ''
	});

	React.useEffect(() => {
		if (id) {
			props.setLoading(true)
			getInvestigation(id).then((res: any) => {
				let investigation = res.data
				let date = new Date(investigation.date_created);
				let dateStr = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
				investigation.date_created = dateStr;
				setInvestigation(investigation);
				props.setLoading(false)
			}).catch((err: any) => {
				props.setLoading(false)
				console.log(err)
			});
		}
	}, [id]);


	const [openCreate, setOpenCreate] = useState(false);
	
	const handleCreateNewItem = () => {
		// history.push(`/investigations/new`);
		setOpenCreate(true)
	};

	const handleCloseCreate = () => {
		setOpenCreate(false)
	}

    const handleViewUser = () => {
        history.push(`/experts/details/${Investigation.expertId}`)
    }
	
	return (
		<div className={classes.root}>

			<BackBanner title={'Investigation Details'} />
			<Card className={cardStyles.card}>
				<Box boxShadow={4}>
					<CardHeader
						className={cardStyles.cardHeader}
						classes={{
							title: cardStyles.headerTitle,
						}}
						action={
							// Investigation.isOwner ?
							<>
								<IconButton onClick={handleClick} aria-label='settings'>
									<MoreVert className={classes.editIcon} />
								</IconButton>
								<Popover
									id={id}
									open={open}
									anchorEl={anchorEl}
									onClose={handleClose}
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'center',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'center',
									}}
								>
									<Box className={classes.popupButton}>
										<UpdateButton className={classes.updateButton} 
											onClick={handleOpenForm}
											message='Update' />
										<DeleteButton onClick={handleOpenDelete}
											className={classes.deleteButton} 
											message='Delete' />
									</Box>
								</Popover>
							</> 
							// : <></>
						}
						title={`${Investigation.name}`}
					/>
				</Box>
				<CardContent>
					<Typography variant='h5'>Description:</Typography>
					<Box className={cardStyles.sectionContent}>
						<Typography>
							{Investigation.description
								? Investigation.description
								: 'No description'}
						</Typography>
					</Box>
					<Grid container alignItems='flex-end' xs={12} className={classes.gridItemWrapper}>
						<Grid item xs={8}>
							<Typography
								variant='h5'
								className={cardStyles.sectionTitle}
							>
								Tasks:
							</Typography>
						</Grid>
						<Grid item xs={4} className={classes.gridItemWrapper}>
						{/* {Investigation.isOwner? */}
							<SubmitButton
								icon={<AddBoxIcon />}
								message={`Create a task`}
								onClick={handleCreateNewItem}
								className={classes.createItemButton}
							/>
							{/* : <></> */}
						{/* } */}
						<Dialog
							open={openCreate}
							fullWidth
							// className={classes.form}
							keepMounted
							onClose={handleCloseCreate}
							aria-labelledby="alert-dialog-slide-title"
							aria-describedby="alert-dialog-slide-description"
						>
							<CreateTask investigationId={id} />
						</Dialog>
						</Grid>
					</Grid>
					<Box className={cardStyles.sectionContent}>
						<ItemList
							// append={`${`Investigations/details/${id}/`}`}
							name='Tasks'
							isUser={false}
							items={Investigation.tasks}
						/>
					</Box>

					<Grid
						container
						xs={12}
						className={`${classes.userWrapper}`}
                        onClick={handleViewUser}
					>
						<Grid item xs={8}>
							<AccountCircle className={classes.userProfile} />
							<Typography
								className={classes.userName}
								variant='h5'
							>
								{Investigation.created_by}
							</Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								className={classes.userDate}
								variant='subtitle1'
							>
								{Investigation.date_created}
							</Typography>
						</Grid>
						{/* <UserCardHeader /> */}
					</Grid>
				</CardContent>
			</Card>
			<Dialog
				open={openUpdate}
				fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleCloseUpdate}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<UpdateInvestigation handleClose={handleCloseUpdate} setInvestigation={setInvestigation} investigation={Investigation} />
			</Dialog>
			<Dialog
				open={openDelete}
				// fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleCloseDelete}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>	
				<DeleteItemConfirmation id={Investigation.id} confirmationText={Investigation.name} name="investigation" onSubmit={deleteInvestigation} />
			</Dialog>
		</div>
	);
};

export default IsLoadingHOC(InvestigationDetail);
